// extracted by mini-css-extract-plugin
export default {"shadowed":"About_shadowed__g9vNv","pink":"About_pink__M4dG0","green":"About_green__ZJHNB","skills":"About_skills__eVWgg"};